<template>
  <basic-card>
    <template slot="header">
      {{ $t("cashflow.reportDefinitions") }}
      <context-help help-item-code="cashflow-report-definitions-view"/>
    </template>
    <data-table
        :data="internalDefinitions"
        :configuration="definitionTableConfig"
        @add="addDefinition"
        @delete="deleteDefinition"
        @duplicate="duplicateDefinition"
        @focusedChanged="focusedChanged"
        component-id="cashflow-definitions-list"
    >
      <cashflow-report-definition-card
          v-if="focusedDefinition != null"
          :definition="focusedDefinition"
          @save="handleSave"

      />
    </data-table>
  </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import DashboardLayout from "../components/layout/DashboardLayout";
import {mapGetters} from "vuex";

import FormTextInput from "../components/form/FormTextInput";
import FormSelectInput from "../components/form/FormSelectInput";
import FormCheckboxInput from "../components/form/FormCheckboxInput"
import SimpleHorizontalLayout from "../components/layout/SimpleHorizontalLayout";
import Empty from "../components/layout/Empty";
import SimpleButton from "../components/button/SimpleButton";
import CashflowReportDefinitionCard from "../cards/CashflowReportDefinitionCard";
import DataTable from "../components/table/DataTable";
import Loader from "../components/Loader";
import ContextHelp from "../components/help/ContextHelp";

export default {
  name: "CashflowView",
  components: {
    ContextHelp,
    Loader,
    DataTable,
    CashflowReportDefinitionCard,
    SimpleButton,
    Empty,
    SimpleHorizontalLayout,
    FormCheckboxInput, FormSelectInput, FormTextInput, DashboardLayout, BasicCard
  },
  data: function () {
    return {
      internalDefinitions: [],
      focusedDefinition: null,
      definitionTableConfig: {
        allowEdit: true,
        enableAdd: true,
        columns: [
          {
            caption: this.$t("cashflow.definition.name"),
            datum: d => d.name
          },
          {
            caption: this.$t("cashflow.definition.reportCurrency"),
            datum: d => d.reportCurrency
          },
          {
            caption: this.$t("cashflow.definition.startDateExpression"),
            datum: d => {
              let formatted = this.$formats.formatDate(d.startDateExpression);
              if (formatted == 'Invalid date') return d.startDateExpression
              else return formatted;
            }
          },
          {
            caption: this.$t("cashflow.definition.endDateExpression"),
            datum: d => {
              let formatted = this.$formats.formatDate(d.endDateExpression);
              if (formatted == 'Invalid date') return d.endDateExpression
              else return formatted;
            }
          }
        ],
        actions: [
          {
            name: "delete",
            icon: "trash",
            tooltip: this.$t("cashflow.definition.deleteTooltip")
          },
          {
            name: "duplicate",
            icon: "copy",
            tooltip: this.$t("cashflow.definition.duplicateTooltip")
          }
        ]
      }
    }
  },
  mounted() {
    this.$store.dispatch("cashEventFieldDistincts/refreshAllFields");
    this.refreshData();
  },
  computed: {
    ...mapGetters({
      definitions: "cashflowReportDefinitions/cashflowReportDefinitions",
    })
  },
  methods: {
    focusedChanged(focused) {
      this.focusedDefinition = focused;
    },
    addDefinition() {
      this.focusedDefinition = {
        columns: [],
        balanceColumns: [],
        convertToReportCurrency: true,
        reportCurrency: "CZK",
        startDateExpression: "-10d",
        endDateExpression: "1lom>5d",
        breakDateExpression: "0d",
        projectOperationsToBalances: true,
        useBreakDateForProjection: true
      };
      this.internalDefinitions.push(this.focusedDefinition);
    },
    deleteDefinition(definition) {
      if (this.focusedDefinition != null && this.focusedDefinition.id == definition.id) {
        this.focusedDefinition = null;
      }
      this.$store.dispatch("cashflowReportDefinitions/deleteCashflowReportDefinition", definition)
          .then(this.refreshData)
    },
    duplicateDefinition(definition) {
      this.focusedDefinition = {...definition, id: undefined, name: "Copy of " + definition.name}
    },
    handleSave(definition) {
      this.$store.dispatch("cashflowReportDefinitions/saveCashflowReportDefinition", definition)
          .then(this.refreshData);
      this.focusedDefinition = null;
    },
    refreshData() {
      this.$store.dispatch("cashflowReportDefinitions/refreshCashflowReportDefinitions")
          .then(() => {
            this.internalDefinitions = this.$_.cloneDeep(this.definitions)
                .sort((a, b) => a.order - b.order);
          })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/global";


</style>
